// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import 'myWorld/controls/datePicker';
import './fieldEditor';

/**
 * Input for fields of type Date. <br/>
 * Text input that when selected will display a datepicker calendar which the user can use to choose a date
 * @name DateFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.DateFieldEditor = myw.FieldEditor.extend({
    events: _.extend({}, myw.FieldEditor.prototype.events, {
        focus: 'blur' // to avoid opening the soft keyboard on touch devices
    }),

    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        this.control = new myw.Input({
            value: this.fieldValue,
            onChange: this._changed.bind(this)
        });
        const element = this.control.$el.datepicker({
            dateFormat: 'yy-mm-dd' // needs to be the format the server will accept. ENH: have localisation of date formats in UI
        });
        this.setElement(element);
    },

    blur() {
        this.control.$el.blur();
    },

    /**
     * Overriden to handle date instances
     * @param {string|Date} value
     */
    setValue(value) {
        if (value instanceof Date) {
            value = value.toISOString().slice(0, 10);
        }
        //call super
        myw.FieldEditor.prototype.setValue.call(this, value);
    },

    validateValue(value) {
        const date = new Date(value);
        if (date != 'Invalid Date') return true;
        else return this.msg('date_required');
    }
});

export default myw.DateFieldEditor;
